import React, { useMemo } from "react";
import objectPath from "object-path";
import { NavLink, useHistory, Redirect, Link } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
// Import Layout components

const Layout = (props) => {
const logoutClick = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("userNo");
    localStorage.removeItem("userId");
    localStorage.removeItem("userRole");
    localStorage.removeItem("expirationDate");

    window.localStorage.removeItem("botAdminId");
    window.localStorage.removeItem("botAdminNo");

    window.location.href = "/";
};

  return (
    <div className="d-flex flex-column flex-root">
      {/*begin::Login*/}
      <div
        className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white"
        id="kt_login"
      >
        {/*begin::Aside*/}
        <div
          className="login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 p-lg-10"
          style={{
            backgroundImage:
              "linear-gradient(127deg, #ff6f5e, #ffa45e 51%, #ff5edb 99%)",
            width: 400,
          }}
        >
          {/*begin: Aside Container*/}
          <div className="d-flex flex-row-fluid flex-column justify-content-between">
            {/* start:: Aside header */}
            <Link to="/" className="flex-column-auto mt-5 pb-lg-0 pb-10">
              <img
                alt="Logo"
                className="max-h-70px"
                src={toAbsoluteUrl("/media/logos/account-logo3x.png")}
              />
            </Link>
            {/* end:: Aside header */}

            {/* start:: Aside content */}
            {/* <div className="flex-column-fluid d-flex flex-column justify-content-center">
								<h3 className="font-size-h1 mb-5 text-white">
									Welcome to Aimily!
								</h3>
								<p className="font-weight-bold text-white opacity-80">
									The easy and simple RPA solution for effective and innovation
									business.
								</p>
							</div> */}
            {/* end:: Aside content */}

            {/* start:: Aside footer for desktop */}
            <div className="d-none flex-column-auto d-lg-flex justify-content-between mt-10">
              <div className="opacity-70 font-weight-bold text-white">
                COPYRIGHT &copy; 2021 AIMILY. ALL RIGHTS RESERVED
              </div>
            </div>
            {/* end:: Aside footer for desktop */}
          </div>
          {/*end: Aside Container*/}
        </div>
        {/*begin::Aside*/}

        {/*begin::Content*/}
        <div className="d-flex flex-column flex-row-fluid position-relative p-7 overflow-hidden">
                  {/*begin::Content header*/}
                  {localStorage.getItem("token") != null && (
                      <div style={{position: "absolute",right: "45px",top: "40px"}}>
                          <button class="btn btn-danger" type="button" onClick={logoutClick}>로그아웃</button>
                      </div>
					)}
          <div className="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10">
            {/* <span className="font-weight-bold text-dark-50">
								아직 계정이 없으신가요?
							</span> */}
            {/* <Link
                to="/auth/registration"
                className="font-weight-bold ml-2"
                id="kt_login_signup"
              >
                My AIMILY
              </Link> */}
          </div>
          {/*end::Content header*/}

          {/* begin::Content body */}
          <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
            {/* <Switch>
              <ContentRoute path="/auth/login" component={Login} />
              <ContentRoute
                path="/auth/registration"
                component={Registration}
              />
              <ContentRoute
                path="/auth/forgot-password"
                component={ForgotPassword}
              />
              <ContentRoute path="/PageId18" component={PageId18} />
              <ContentRoute path="/licenseList" component={LicenseList} />
              <ContentRoute path="/buyLicense" component={BuyLicense} />
              <Redirect from="/auth" exact={true} to="/auth/login" />
              <Redirect to="/auth/login" />
            </Switch> */}
            {props.children}
          </div>
          {/*end::Content body*/}

          {/* begin::Mobile footer */}
          <div className="d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5">
            <div className="text-dark-50 font-weight-bold order-2 order-sm-1 my-2">
              COPYRIGHT &copy; 2021 AIMILY. ALL RIGHTS RESERVED
            </div>
          </div>
          {/* end::Mobile footer */}
        </div>
        {/*end::Content*/}
      </div>
      {/*end::Login*/}
    </div>
  );
};

export default Layout;
